import { css } from "styled-components";

// The keyboard focus indicator for every control: a 2px outline in the
// primary colour, 2px off the edge. On its own for a control that draws focus
// on another element (`input:focus-visible + label { ${focusOutlineRule} }`).
export const focusOutlineRule = css`
  outline: 2px solid ${({ theme }) => theme.primary};
  outline-offset: 2px;
`;

// The same rule on the element itself. The global button reset drops the
// browser's outline, so every button-like control opts back in with this.
export const focusOutline = css`
  &:focus-visible {
    ${focusOutlineRule}
  }
`;
